import React from 'react';
import ReactDOM from 'react-dom';
import DmbPlugin from './app';

ReactDOM.render(
  <DmbPlugin />,
  document.querySelector('#app')
);